import React from 'react';
import { Link } from 'react-router-dom';
import MarketingShell from './MarketingShell';
import MarketingLoginLink from './MarketingLoginLink';
import './marketing.css';

export default function ProductShell({
  title,
  eyebrow = 'Product',
  lead,
  children,
  ctaLabel = 'Start free — sign in',
  ctaTo = '/login',
  ctaRedirect,
  layout,
}) {
  const cta =
    ctaTo === '/login' ? (
      <MarketingLoginLink className="marketing-btn marketing-btn-primary product-cta" redirect={ctaRedirect}>
        {ctaLabel}
      </MarketingLoginLink>
    ) : (
      <Link to={ctaTo} className="marketing-btn marketing-btn-primary product-cta">
        {ctaLabel}
      </Link>
    );

  return (
    <MarketingShell variant="product" layout={layout}>
      <div className="product-hero-band">
        <span className="product-eyebrow">{eyebrow}</span>
        {title && <h1 style={{ margin: '8px 0 0', fontSize: 'clamp(1.5rem, 3vw, 2rem)' }}>{title}</h1>}
        {lead && <p className="product-lead">{lead}</p>}
        {cta}
      </div>
      <div className="product-body">{children}</div>
    </MarketingShell>
  );
}
